export const CASHIER_ITEM_TYPE = {
  PRODUCT: 'PRODUCT',
  GIFT_CARD: 'GIFT_CARD',
  VIP: 'VIP',
};

export const PAYMENT_TYPE = {
  CASH: 'CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  GIFT_CREDIT: 'GIFT_CREDIT',
  CHECK: 'CHECK',
  GIFT_CARD: 'GIFT_CARD',
  LOYALTY_POINT: 'LOYALTY_POINT',
  PAYPAL: 'PAYPAL',
  VENMO: 'VENMO',
  CASH_APPS: 'CASH_APPS',
  ZELLE: 'ZELLE',
  ONLINE_CARD: 'ONLINE_CARD',
  EBT_FOOD: 'EBT_FOOD',
  EBT_CASH: 'EBT_CASH',
};

export enum SHOP_DEVICE_TYPE {
  SIGNATURE = 'SIGNATURE',
  POS = 'POS',
}